export default function TopThreatsByProcessController(
  $q,
  $scope,
  bcpDataService,
  loaderService,
  editTopThreatsByProcessDialog,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleExpand = _handleExpand;
  vm.handleEditTopThreatsByProcess = _handleEditTopThreatsByProcess;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _activate() {
    _initPermissions();
  }

  function _initPermissions() {
    vm.canExpand = true;
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadTopThreatsByProcess();
    }
    return Promise.resolve();
  }

  function _handleEditTopThreatsByProcess($event) {
    _loadTopThreatsByProcess().then(() => _openEditTopThreatsByProcessDialog($event, {
      assessmentId: vm.assessmentId,
      processes: vm.processes,
    }));
  }

  /** *********************************************
   * Private Functions
   */

  function _loadTopThreatsByProcess() {
    loaderService.showViewLoader = true;
    return bcpDataService.getProcessesByUser(vm.assessmentId)
      .then((response) => {
        loaderService.showViewLoader = false;
        vm.processes = response.data.result;
        vm.hasData = true;
      });
  }

  function _openEditTopThreatsByProcessDialog($event, locals) {
    ssDialogService.dialogs.bcp.editTopThreatsByProcessDialog = ssDialogService.alert(
      editTopThreatsByProcessDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editTopThreatsByProcessDialog);
  }
}

TopThreatsByProcessController.$inject = [
  '$q',
  '$scope',
  'bcpDataService',
  'loaderService',
  'editTopThreatsByProcessDialog',
  'ssDialogService',
  'userService'
];
